var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-height",staticStyle:{"overflow-y":"auto","overflow-x":"hidden"}},[_c('div',{staticClass:"overview-map",attrs:{"id":_vm.regionMapId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }